var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProbe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 6.58604L17.4139 3.00004C16.6349 2.22004 15.3649 2.22004 14.5859 3.00004L9.99995 7.58604C9.27595 8.31004 9.23295 9.44904 9.85195 10.234L4.10895 15.977L2.54395 21.456L8.02295 19.891L13.7659 14.148C14.1279 14.434 14.5609 14.586 14.9989 14.586C15.5109 14.586 16.0229 14.391 16.4129 14.001L20.9989 9.41504C21.7789 8.63504 21.7789 7.36704 20.9989 6.58704L20.9999 6.58604ZM6.97695 18.109L5.45595 18.544L5.89095 17.023L11.2499 11.664L12.3359 12.75L6.97695 18.109ZM14.9999 12.586L11.4139 9.00004L15.9989 4.41304L19.5859 8.00004L14.9999 12.586Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99995 12.258V5.00004H9.75795L11.7579 3.00004H4.99995C3.89495 3.00004 2.99995 3.89504 2.99995 5.00004V14.257L4.99995 12.257V12.258Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 14.2421V19.0001H11.7419L9.74189 21.0001H18.9999C20.1049 21.0001 20.9999 20.1051 20.9999 19.0001V12.2431L18.9999 14.2431V14.2421Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProbe);
export default __webpack_public_path__ + "static/media/icon-probe.4f18411873fcf27ceeea0c7bbb233b85.svg";
export { ForwardRef as ReactComponent };